import React from 'react';
import { PureBreadcrumbsItem } from '@base/lib/PureBreadcrumbs';
import Breadcrumbs from '@app/common/Breadcrumbs';
import { IVariant } from 'base/interfaces/product';

type ProdBreadcrumbsProps = {
    variant: IVariant;
};

const ProdBreadcrumbs: React.FC<ProdBreadcrumbsProps> = ({ variant }) => {
    const list: PureBreadcrumbsItem[] = [];
    const categoryInfo = variant?.categoryInfo
    const variantName = variant?.name
    if (categoryInfo) {
        list.push({
            name: categoryInfo.catName,
            url: categoryInfo.catLinkUrl,
        });
    }
    if (variantName) {
        list.push({
            name: variantName,
        });
    }
    return list.length ? <Breadcrumbs list={list}/> : null;
};

export default ProdBreadcrumbs;